
const AUTH_USER = 'AUTH_USER';
const AUTH_TOKEN = 'AUTH_TOKEN';
const USER_LOCATION = 'USER_LOCATION';
const USER_INTENT = 'USER_INTENT';


/* ================= SAVE AUTH ================= */
export const saveAuth = async (token, user) => {
    try {
        await localStorage.multiSet([
            ["AUTH_USER", JSON.stringify(user)],
            ["AUTH_TOKEN", token],
        ]);
    } catch (e) {
        console.log("Save auth error", e);
    }
};


/* ================= SAVE USER INTENT ================= */
// intent example: "looking_for_services" | "looking_for_clients"
export const saveUserIntent = async (intent) => {
    try {
        await localStorage.setItem(USER_INTENT, intent);
    } catch (e) {
        console.log('Save user intent error', e);
    }
};


/* ================= SAVE USER LOCATION ================= */
export const saveUserLocation = async (location) => {
    try {
        await localStorage.setItem(
            USER_LOCATION,
            JSON.stringify(location)
        );
    } catch (e) {
        console.log('Save user location error', e);
    }
};


/* ================= GET AUTH ================= */
export const getAuth = async () => {
    try {
        
        const data = await localStorage.multiGet([
            AUTH_USER,
            AUTH_TOKEN,
            USER_LOCATION,
            USER_INTENT,
        ]);

        return {
            user: data[0][1] ? JSON.parse(data[0][1]) : null,
            token: data[1][1] || null,
            location: data[2][1] ? JSON.parse(data[2][1]) : null,
            intent: data[3][1] || null,
        };
    } catch (e) {
        return {
            user: null,
            token: null,
            location: null,
            intent: null,
        };
    }
};

/* ================= CLEAR AUTH ================= */
export const clearAuth = async () => {
    try {
        await localStorage.multiRemove([
            AUTH_USER,
            AUTH_TOKEN,
            USER_LOCATION,
            USER_INTENT,
        ]);
    } catch (e) {
        console.log('Clear auth error', e);
    }
};
